function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const PenIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.313 3.813a318.01 318.01 0 0 0-2.239 2.209C4.236 7.86-.079 12.979 0 15.999c3.02.08 8.139-4.236 9.977-6.074a318.01 318.01 0 0 0 2.209-2.239L8.313 3.813zm6.448-.623l-.282-.281L16 1.652 14.348 0l-1.257 1.521-.282-.282c-.872-.051-2.278.793-3.663 1.907l3.707 3.707c.419-.521.798-1.045 1.107-1.542.93.767.243 3.017-3.682 5.967L11 12c3.5-2.5 5.766-5.5 3.571-7.882.131-.346.205-.663.19-.928z"
  }));
};
export default PenIcon;